import React from 'react';
import Select from 'app/components/Select';
import { useLazyGetTemplatesQuery } from 'app/features/templates/api';
import { FC, useMemo } from 'react';
import { Button, Space } from 'antd';
import ModalEditInspectionTemplate from 'app/pages/BookInspection/components/Modals/EditInspectionTemplate';
import { useLazyLoadOption } from 'app/hooks/useLazyLoadOption';
import { ITemplate } from 'app/pages/TemplateManagment/context';

interface Props {
  allTemplates: Array<any>;
  productProfileId: number;
  openEditTemplate: boolean;
  selectedTemplate: any;
  defaultTemplate: ITemplate;
  currentSelectedTemplate: any;
  onChangeTemplate: (option: any) => void;
  onClickEdit: () => void;
  onCancelEdit: () => void;
  onOkEdit: (values: any) => void;
}

const SelectTemplate: FC<Props> = ({
  allTemplates,
  productProfileId,
  openEditTemplate,
  selectedTemplate,
  currentSelectedTemplate,
  defaultTemplate,
  onChangeTemplate,
  onClickEdit,
  onCancelEdit,
  onOkEdit
}) => {
  /**
   * Should using lazy load to load template of product.
   */
  const [fetchTemplates, stateResponse] = useLazyGetTemplatesQuery();

  const { data: templatesData, onScroll } = useLazyLoadOption({
    fetch: async (pagination) => {
      const { data: response }: any = await fetchTemplates({
        current: pagination.currentPage,
        pageSize: 10,
        status: 'active',
        productProfileId: productProfileId
      } as any).unwrap();
      return response;
    }
  });

  const templateOptions = useMemo(() => {
    return templatesData.map((template) => ({
      value: template.id,
      label: `${template.name} ${
        template.isDefault ? '(Default Template)' : ''
      }  `,
      data: template
    }));
  }, [templatesData]);

  const currentSelected = React.useMemo(() => {
    if (!templateOptions.length && !currentSelectedTemplate)
      return defaultTemplate;
    if (templateOptions.length && !currentSelectedTemplate)
      return templateOptions[0];

    const selected = templateOptions.find(
      ({ label, data }) =>
        label === currentSelectedTemplate?.name ||
        data?.name === currentSelectedTemplate?.name
    );
    return selected || currentSelectedTemplate?.name || templateOptions[0];
  }, [currentSelectedTemplate, templateOptions, defaultTemplate]);

  React.useEffect(() => {
    //If scheme does not have that it mean still not yet select any template.
    if (!currentSelectedTemplate?.scheme && currentSelected) {
      onChangeTemplate(currentSelected);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSelected, currentSelectedTemplate]);

  return (
    <Space>
      <Select
        loading={stateResponse.isLoading}
        onPopupScroll={onScroll}
        style={{ width: 500 }}
        placeholder="Select template"
        value={currentSelected}
        options={templateOptions}
        onChange={(value: any, option: any) => {
          onChangeTemplate(option);
        }}
      />
      <Button type="link" onClick={onClickEdit}>
        Edit Template
      </Button>

      {openEditTemplate && (
        <ModalEditInspectionTemplate
          destroyOnClose
          onCancel={onCancelEdit}
          onOk={onOkEdit}
          selectedTemplate={selectedTemplate}
          open={openEditTemplate}
          templates={allTemplates}
        ></ModalEditInspectionTemplate>
      )}
    </Space>
  );
};

export default SelectTemplate;
